import { FeatureFlag } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { WIDGET_WEIGHTS } from './constants';
import { ExpediaWidget } from './ExpediaWidget';
import { FlexkeepingWidget } from './FlexkeepingWidget';
import { HotelsForTreesWidget } from './HotelsForTreesWidget';
import { HousekeepingWidget } from './HousekeepingWidget';
import { SmsWidget } from './SmsWidget';
import { DigitalKeyWidget } from './DigitalKeyWidget';
import { DayuseWidget } from './DayuseWidget';
import { UberWidget } from './UberWidget';
import { TerminalS2Widget } from './TerminalS2Widget';
import { MewsUniversityWidget } from './MewsUniversityWidget';

export const useMarketplaceWidgets = () => {
    const isMarketplaceSmsWidgetEnabled = useFeatureFlag(FeatureFlag.marketplaceSmsWidgetEnabled);
    const isSmsIntegrationEnabled = useFeatureFlag(FeatureFlag.smsIntegrationEnabled);
    const isFlexkeepingWidgetEnabled = useFeatureFlag(FeatureFlag.marketplaceFlexkeepingWidgetEnabled);
    const isHousekeepingWidgetEnabled = useFeatureFlag(FeatureFlag.marketplaceHousekeepingWidgetEnabled);
    const isDigitalKeyWidgetEnabled = useFeatureFlag(FeatureFlag.marketplaceDigitalKeyWidgetEnabled);
    const isUberWidgetEnabled = useFeatureFlag(FeatureFlag.marketplaceUberWidgetEnabled);
    const isMewsTerminalS2AdEnabled = useFeatureFlag(FeatureFlag.mewsTerminalS2AdEnabled);

    const availableWidgets = [
        {
            component: <HotelsForTreesWidget />,
            weight: WIDGET_WEIGHTS.hotelsForTrees,
        },
        {
            component: <ExpediaWidget />,
            weight: WIDGET_WEIGHTS.expedia,
        },
        {
            component: <DayuseWidget />,
            weight: WIDGET_WEIGHTS.dayuse,
        },
        {
            component: <MewsUniversityWidget />,
            weight: WIDGET_WEIGHTS.mewsUniversity,
        },
    ];

    if (isSmsIntegrationEnabled && isMarketplaceSmsWidgetEnabled) {
        availableWidgets.push({
            component: <SmsWidget />,
            weight: WIDGET_WEIGHTS.sms,
        });
    }

    if (isFlexkeepingWidgetEnabled) {
        availableWidgets.push({
            component: <FlexkeepingWidget />,
            weight: WIDGET_WEIGHTS.flexkeeping,
        });
    }

    if (isHousekeepingWidgetEnabled) {
        availableWidgets.push({
            component: <HousekeepingWidget />,
            weight: WIDGET_WEIGHTS.housekeeping,
        });
    }

    if (isDigitalKeyWidgetEnabled) {
        availableWidgets.push({
            component: <DigitalKeyWidget />,
            weight: WIDGET_WEIGHTS.digitalKey,
        });
    }

    if (isUberWidgetEnabled) {
        availableWidgets.push({
            component: <UberWidget />,
            weight: WIDGET_WEIGHTS.uber,
        });
    }

    if (isMewsTerminalS2AdEnabled) {
        availableWidgets.push({
            component: <TerminalS2Widget />,
            weight: WIDGET_WEIGHTS.terminalS2,
        });
    }

    return availableWidgets;
};
